import { Heading } from "@dip/helsecore/src/components/shared/Heading/Heading";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { Button } from "@hdir/ui/button";
import { Link } from "@hdir/ui/link";
import { TextField } from "@hdir/ui/text-field";
import React, { useState, useRef } from "react";

import FontAwesomeIconWrapper from "../../../react4xp/shared/FontAwesomeIconWrapper/FontAwesomeIconWrapper";
import { LimitedSearchPropsType } from "./types.d";

function LimitedSearch(props: Readonly<LimitedSearchPropsType>) {
  const {
    contentsLinkText,
    description,
    filterWords,
    image,
    imageAltText,
    layoutHasTitle,
    phrases,
    searchLabel,
    searchResultHref,
    title
  } = props;

  const [error, setError] = useState("");
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const searchText = searchInputRef.current?.value;
    if (!searchText) {
      setError(phrases["search.searchError"]);
      searchInputRef.current?.focus();
      return;
    }
    const encodedValue = encodeURIComponent(searchText);
    let searchUrl = `${searchResultHref}?q=${encodedValue}`;
    if (filterWords) {
      searchUrl = `${searchUrl}&filter=${filterWords}`;
    }
    window.location.href = searchUrl;
  };

  return (
    <div className="py-design-component-mobile tablet:py-design-component-tablet desktop:py-design-component-desktop">
      <div
        className={`flex nt-flex-col bg-surface-neutral-subtle ${image && "items-stretch tablet:items-center"} px-lg py-xl tablet:nt-flex-row tablet:px-xxxl tablet:py-xxl`}
      >
        {image
          && (
            <div className="flex justify-center w-full tablet:w-1/3">
              <img
                className="w-full tablet:w-4/5 h-auto max-h-60 mr-0 mb-xxl object-contain desktop:mr-md desktop:mb-0"
                src={image}
                alt={imageAltText ?? ""}
              />
            </div>
          )}
        <form className="search-content break-normal hyphens-auto w-full tablet:w-2/3 tablet:ml-md" onSubmit={(e) => handleSearch(e)}>
          <Heading headingLevel={layoutHasTitle ? "h3" : "h2"} className="mb-xs">{title}</Heading>
          <p className="text-md mb-lg">{description}</p>
          <div className={`search-bar my-xl mx-0 flex ${error ? "items-center" : "items-end"}`}>
            {
              // TODO: should be replaced by https://designsystem.helsedir.no/0410c9e94/p/246586-search
              // from the designsystem after it gets live.
            }
            <FontAwesomeIconWrapper
              icon={faSearch}
              style={{ color: "var(--design-color-icon-action-default)" }}
              className={`search-icon absolute pl-md z-10 ${error ? "mt-inherit tablet:mt-0" : "pb-sm"}`}
            />
            <TextField
              className="search-input min-w-[65%]"
              placeholder={phrases["search.placeholder"]}
              label={searchLabel}
              name="search-text"
              type="text"
              error={error}
              ref={searchInputRef}
            />
            <Button
              loadingText={phrases["search.ongoing"]}
              size="medium"
              variant="primary"
              onClick={handleSearch}
              className={`${error ? "mt-inherit tablet:mt-xs" : ""}`}
            >
              {phrases["search.search"]}
            </Button>
          </div>
          {(contentsLinkText && searchResultHref) && <Link href={searchResultHref}>{contentsLinkText}</Link>}
        </form>
      </div>
    </div>
  );
}

export default function(props: Readonly<LimitedSearchPropsType>) {
  return <LimitedSearch {...props} />;
}
